export default "__VITE_ASSET__B5QP6YBP__";